/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import {Progress} from 'antd';
import IconFont from 'Components/common/iconFont';

import './index.less';

class CircleAudio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPlaying: props.isPlay || false, // 播放状态
      percent: 0,
      start: props.start || 0,
      end: props.end || 0,
    };
    this.audio = null;
  }

  componentDidMount() {
    const {isPlaying} = this.state;

    this.audio.addEventListener('canplaythrough', this.onCanPlayThrough, false);
    this.audio.addEventListener('timeupdate', this.timeupdate, false);

    if (isPlaying) {
      this.toggle(true);
    }
  }

  componentWillUnmount() {
    this.audio.removeEventListener(
      'canplaythrough',
      this.onCanPlayThrough,
      false,
    );
    this.audio.removeEventListener('timeupdate', this.timeupdate, false);
  }

  onCanPlayThrough = () => {
    if (!this.audio) return;
    const {end = 0, start = 0} = this.props;
    const {duration} = this.audio;

    if (!end) {
      this.setState({
        end: duration,
      });
    } else {
      this.setState({
        start: start / 1000,
        end: end / 1000,
      });
    }
  };

  timeupdate = () => {
    const {start, end} = this.state;
    const percent = Math.floor(
      ((this.audio.currentTime - start) / (end - start)) * 100,
    );

    this.setState({
      percent,
    });

    if (this.audio.currentTime - end >= 0) {
      this.toggle(false);
    }
  };

  toggle = isPlay => {
    const {
      audio,
      props: {replay = true, onChange = () => {}},
      state: {start, end},
    } = this;

    if (
      isPlay &&
      replay &&
      (audio.currentTime === 0 || audio.currentTime >= end)
    ) {
      audio.currentTime = start;
    }

    this.setState(
      {
        isPlaying: isPlay,
      },
      () => {
        audio[isPlay ? 'play' : 'pause']();
        onChange(isPlay);
      },
    );
  };

  onClick = () => {
    const {isPlaying} = this.state;

    this.toggle(!isPlaying);
  };

  render() {
    const {source} = this.props;
    const {percent, isPlaying} = this.state;

    return (
      <div className="circle-audio">
        {/* 音频播放器 */}
        <audio
          src={source}
          controls="controls"
          ref={c => {
            this.audio = c;
          }}>
          Your browser does not support the audio element.
        </audio>

        <div className="circle-audio-play">
          <Progress
            format={() => (
              <IconFont
                className={isPlaying ? '' : 'icon-play'}
                onClick={this.onClick}
                type={
                  isPlaying ? 'icon-robotbofang' : 'icon-robottriangle-right'
                }
              />
            )}
            strokeWidth={7}
            type="circle"
            percent={percent}
            width={24}
          />
        </div>
      </div>
    );
  }
}

export default CircleAudio;
